import React from "react";
import Slider from "react-slick";
import PropTypes from "prop-types";
import Modal from "../../shared/modal";
import styles from "./styles.css";
import CloseButton from "../../shared/icon-cross";
import { fastlyUrl, imageTypes } from "../../../utils/helpers/cdn-image-url";

const ImageSliderModal = ({images, config, onClose, selectedSlide = 0, isAbsoluteImageUrls = false}) => {
    const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrow: true,
        dots: false,
        infinite: false,
        initialSlide: selectedSlide
    };
    return (
        <Modal isOpen={true} close={onClose}>
            <div styleName={"styles.sliderWrapper"}>
                <Slider {...settings}>
                    {(images || []).map((item, index) => {
                        const {image, featureName = "", subtitle} = item;
                        return (
                            <div key={index} styleName={"styles.imageWrapper"}>
                                <div styleName="styles.closeButton">
                                    <CloseButton type="white" onClickHandler={onClose} />
                                </div>
                                <img src={isAbsoluteImageUrls ? image : fastlyUrl(config?.imageHost, image, imageTypes.auCarDetailPreview)} />
                                {featureName?.trim()?.length > 0 && <p styleName={"styles.caption"}>{featureName}</p>}
                                {subtitle?.trim()?.length > 0 && <p styleName={"styles.subCaption"}>{subtitle}</p>}
                            </div>
                        );
                    })}
                </Slider>
            </div>
        </Modal>
    );
};

ImageSliderModal.propTypes = {
    images: PropTypes.array,
    config: PropTypes.object,
    onClose: PropTypes.func,
    selectedSlide: PropTypes.number,
    isAbsoluteImageUrls: PropTypes.bool
};
export default ImageSliderModal;
